// Bundle entry. Executes after the 21 pristine scripts and before the inline
// bootstrap's load() — the position that lets extracted modules shim pristine
// globals before any save is loaded.

import {
  legacyWindow,
  replaceGlobal,
  restoreGlobal,
  installedShims,
  installWindowBridge,
  installedBridges,
} from './strangler'
import { timeStopped, bigFinishPoint, magicHardcap, platinumUpgrade6Effect } from './transients/index'
import { isDevVersion } from './config'

// Promote the shared transients: bare-identifier access in pristine code now
// resolves through these module-owned boxes (seeded from the values the
// pristine top-level code already set).
installWindowBridge('timeStopped', timeStopped)
installWindowBridge('bigFinishPoint', bigFinishPoint)
installWindowBridge('magicHardcap', magicHardcap)
installWindowBridge('platinumUpgrade6Effect', platinumUpgrade6Effect)
installWindowBridge('isDevVersion', isDevVersion)

legacyWindow.__remaster = {
  step: 3,
  replaceGlobal,
  restoreGlobal,
  installedShims,
  installedBridges,
  transients: { timeStopped, bigFinishPoint, magicHardcap, platinumUpgrade6Effect, isDevVersion },
}
